import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import ChooseTypePopup from "../../../UI/ChooseTypePopup";
import EditAssessmentWithContent from "./EditAssessmentWithContent";
import EditAssessmentWithoutContent from "./EditAssessmentWithoutContent";

const NewAssessment = () => {

    const texts = useSelector(state => state.translate.texts);
    const [typeLesson, setTypeLesson] = useState()
    const [details, setDetails] = useState()
    const { guid } = useParams()
    const location = useLocation()
    const lessonsList = [
        { name: 'fullAssessment', type: 'full', description: 'fullAssessmentDescription' },
        { name: 'emptyAssessment', type: 'empty', description: 'emptyAssessmentDescription' },
    ]

    useEffect(() => {
        if (location.state) {
            setDetails({
                courseName: location.state.courseName,
                tocName: location.state.tocName,
                isProfession: location.state.isProfession,
                studyGroupId: location.state.studyGroupId,
                activityType: location.state.activityType
            })
        }
    }, [])

    return (
        <>
            {details &&
                <>
                    {guid ? <EditAssessmentWithContent idLesson={guid} {...details}></EditAssessmentWithContent> : <>
                        {!typeLesson && <ChooseTypePopup setTypeLesson={setTypeLesson} lessonsList={lessonsList} title={texts.addAssessmentTitle} typeTitle={texts.addSourceTypeTitle} />}
                        {typeLesson === "full" ? <EditAssessmentWithContent {...details} /> :
                            typeLesson === "empty" ? <EditAssessmentWithoutContent {...details} /> : ''}
                    </>
                    }
                </>
            }
        </>
    )
}

export default NewAssessment;